import { Center, Loader, Stack, Text, Box, Image } from '@mantine/core'
import logo from '../assets/logos/AI Analytics logo.svg'

export function LoadingScreen() {
  return (
    <Box 
      style={{ 
        height: '100vh',
        width: '100vw',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999
      }}
    >
      <Center h="100vh">
        <Stack align="center" gap="xl">
          <Box
            style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              padding: '48px',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
            }}
          >
            <Stack align="center" gap="md">
              <Image src={logo} alt="AI Analytics" w={180} fit="contain" />
              <Loader size="lg" color="violet" type="dots" />
              <Text size="sm" c="dimmed" fw={500}>Preparing your dashboard...</Text>
            </Stack>
          </Box>
        </Stack>
      </Center>
    </Box>
  )
}

export default LoadingScreen